module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact fullHeight"
  }, [_c('div', {
    staticClass: "container fullHeight is-fluid noMargin"
  }, [_c('div', {
    staticClass: "columns fullHeight"
  }, [_c('div', {
    staticClass: "column contactHalf fullHeight"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column contactBox"
  }, [_c('h1', [_vm._v("İLETİŞİM")]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v(" TELEFON ")]), _vm._v(" "), _c('p', [_vm._v("+90 533 424 85 00 - +90 533 425 85 00")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" FAKS ")]), _vm._v(" "), _c('p', [_vm._v("+90 212 385 00 05")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" E-POSTA ")]), _vm._v(" "), _c('p', [_vm._v("info@sarikayasahin.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(" ADRES ")]), _vm._v(" "), _c('p', [_vm._v("Balmumcu Mah. Zincirlikuyu Yolu Sok. No: 5/1, Besiktas, Istanbul")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93878026","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/iletisim.vue
// module id = 179
// module chunks = 0